// src/services/fileStorageService.js
import { 
  ref, 
  uploadBytes, 
  getDownloadURL, 
  deleteObject 
} from 'firebase/storage';
import { storage } from '../firebase';

const LENDER_EVIDENCE_PATH = 'payback-evidence';
const BORROWER_EVIDENCE_PATH = 'payback-borrower-evidence';

export const fileStorageService = {
  /**
   * Upload lender evidence file
   */
  async uploadLenderEvidence(reportId, file) {
    try {
      const timestamp = Date.now();
      const fileName = `${reportId}_${timestamp}_${file.name}`;
      const storageRef = ref(storage, `${LENDER_EVIDENCE_PATH}/${reportId}/${fileName}`);
      
      const snapshot = await uploadBytes(storageRef, file);
      const downloadURL = await getDownloadURL(snapshot.ref);
      
      return {
        success: true,
        url: downloadURL,
        path: snapshot.ref.fullPath,
        name: file.name,
        type: file.type
      };
    } catch (error) {
      console.error('Error uploading lender evidence:', error);
      throw error;
    }
  },

  /**
   * Upload borrower evidence file
   */
  async uploadBorrowerEvidence(reportId, file) {
    try {
      const timestamp = Date.now();
      const fileName = `${reportId}_${timestamp}_${file.name}`;
      const storageRef = ref(storage, `${BORROWER_EVIDENCE_PATH}/${reportId}/${fileName}`);
      
      const snapshot = await uploadBytes(storageRef, file);
      const downloadURL = await getDownloadURL(snapshot.ref);
      
      return {
        success: true,
        url: downloadURL,
        path: snapshot.ref.fullPath,
        name: file.name,
        type: file.type
      };
    } catch (error) {
      console.error('Error uploading borrower evidence:', error);
      throw error;
    }
  },

  /**
   * Delete file from storage
   */
  async deleteFile(filePath) {
    try {
      const fileRef = ref(storage, filePath);
      await deleteObject(fileRef);
      return { success: true };
    } catch (error) {
      console.error('Error deleting file:', error);
      throw error;
    }
  },

  /**
   * Convert file to base64 (for preview before upload)
   */
  async fileToBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });
  }
};